// shared.module.ts
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CartComponent } from './components/cart/cart.component';
import { BalanceCashbackComponent } from './components/balance-cashback/balance-cashback.component';
import { CategoryNavComponent } from './components/category-nav/category-nav.component';
import { PipesModule } from 'src/app/shared/pipe/pipe.module';
import { DragScrollDirective } from 'src/app/shared/directives/drag-scroll.directive';
import { OverlayScrollPaddingDirective } from 'src/app/shared/directives/overlay-scroll-padding.directive';
import { ImageItemExpansiveComponent } from 'src/app/shared/components/image-item-expansive/image-item-expansive.component';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [CommonModule, TranslateModule, FormsModule, PipesModule],
    declarations: [CartComponent, CategoryNavComponent, BalanceCashbackComponent, DragScrollDirective, OverlayScrollPaddingDirective, ImageItemExpansiveComponent],
    exports: [CartComponent, CategoryNavComponent, BalanceCashbackComponent, DragScrollDirective, OverlayScrollPaddingDirective, ImageItemExpansiveComponent],
})
export class SharedModule {}
